import * as React from "react";
import { Box, Divider, Grid, Typography, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";

import EmploymentValueChainStageChart from "./Charts/EmploymentValueChainStageChart";
import EmploymentSectorChart from "./Charts/EmploymentSectorChart";
import Circle from "../../../../components/Icons/Circle";

import { StyledItemGraph } from "../../../../components/styles/StyledItemGraph";
import theme from "../../../../components/styles/theme/theme";

export const EmploymentSection: React.FC = () => {
  const isSmScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return !isSmScreen ? (
    <Box id="employmentSection" sx={{ flexGrow: 1 }} padding="140px 25px 50px 25px">
      <Grid item xs={2} sm={2} md={1}>
        <Box sx={{ width: 1 }}>
          <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
            <Box gridColumn="span 12">
              <StyledItemGraph>
                <EmploymentChartSection />
              </StyledItemGraph>
            </Box>
          </Box>
        </Box>
      </Grid>
    </Box>
  ) : (
    <EmploymentChartSection />
  );
};

const EmploymentChartSection: React.FC = () => {
  const { t } = useTranslation();
  const isSmScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grid
      container
      spacing={{ xs: 2, md: 2 }}
      columns={{ xs: 13, sm: 13, md: 13 }}
      justifyContent="center"
      padding="20px 40px"
    >
      <Grid
        item
        xs={13}
        sm={13}
        md={13}
        paddingBottom={!isSmScreen ? "40px" : "10px"}
      >
        <Typography
          variant="h5"
          component="h5"
          fontWeight="600"
          color={(theme) => theme.palette.secondary.main}
        >
          {t("common.employment")}
        </Typography>
      </Grid>

      <Grid
        item
        xs={13}
        sm={13}
        md={6}
        textAlign="start"
        paddingBottom={isSmScreen ? "40px" : 0}
      >
        <Typography
          variant="body2"
          component="span"
          fontWeight="600"
          sx={{ fontSize: "16px" }}
        >
          {t("common.employment")}
          <Circle
            color={theme.palette.secondary.main}
            width="8px"
            height="8px"
            style={{ margin: "0 8px" }}
          />
        </Typography>
        <Typography
          variant="body2"
          component="span"
          color={theme.palette.primary["500"]}
        >
          {t("charts.by_value_chain_stage")}
        </Typography>
        <Typography
          variant="body2"
          component="p"
          color={theme.palette.primary["500"]}
        >
          {t("charts.amount_of_people")}
        </Typography>
        <Box padding={!isSmScreen ? "25px" : 0}>
          <EmploymentValueChainStageChart />
        </Box>
      </Grid>

      {!isSmScreen && (
        <Divider orientation="vertical" flexItem sx={{ margin: "0 auto" }} />
      )}

      <Grid item xs={13} sm={13} md={6} textAlign="start">
        <Typography
          variant="body2"
          component="span"
          fontWeight="600"
          sx={{ fontSize: "16px" }}
        >
          {t("common.employment")}
          <Circle
            color={theme.palette.secondary.main}
            width="8px"
            height="8px"
            style={{ margin: "0 8px" }}
          />
        </Typography>
        <Typography
          variant="body2"
          component="span"
          color={theme.palette.primary["500"]}
        >
          {t("charts.by_sector")}
        </Typography>
        <Typography
          variant="body2"
          component="p"
          color={theme.palette.primary["500"]}
        >
          {t("charts.amount_of_people")}
        </Typography>
        <Box padding={!isSmScreen ? "25px" : 0}>
          <EmploymentSectorChart />
        </Box>
      </Grid>
    </Grid>
  );
};
